@if (employerParty && user) {
  <div class="row mt-2">
    <div class="col-xs-12 col-md-12">
      <div class="row">
        <div class="col-12">
          <button type="button" class="btn mx-1 btn-sm" placement="top" ngbTooltip="{{ 'Template.EmployeesComponent.tooltip_showMore' | translate }}" (click)="isCollapsed = !isCollapsed">
            @if (!isCollapsed) {
              <fa-icon icon="chevron-right"></fa-icon>
            }
            @if (isCollapsed) {
              <fa-icon icon="chevron-up"></fa-icon>
            }
          </button>
          <strong>{{ "Template.EmployeesComponent.text_apiKeys" | translate }}</strong>
          @if (user && user.username) {
            <button class="btn btn-secondary mx-1" (click)="addApiKey(user.username)" placement="top" ngbTooltip="{{ 'Template.EmployeesComponent.tooltip_generateApiKey' | translate }}" [disabled]="!employerParty.enabled">
              <fa-icon icon="plus"></fa-icon>
            </button>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-11">
          <ul class="list-group" [ngbCollapse]="!isCollapsed">
            @for (apiKey of apiKeys.get(user.username); track apiKey) {
              <li class="list-group-item">
                <div class="row">
                  <div class="col-sm-11 col-md-5">
                    @if (user && apiKey && apiKey.decryptedApiKey) {
                      <span>
                        <input type="password" value="{{ apiKey.decryptedApiKey }}" />
                      </span>
                    }
                    @if (user && apiKey && apiKey.apiKeyCreatedDate) {
                      <span>
                        {{ "Template.EmployeesComponent.text_created" | translate : { createdDate: apiKey.apiKeyCreatedDate | date : "d. MMMM yyyy, H:mm:ss" } }}
                      </span>
                    }
                    @if (user && apiKey && apiKey.apiKeyExpirationDate) {
                      <span>
                        @if (apiKey.apiKeyExpirationDate <= 9007199254740992) {
                          <span>
                            {{ "Template.EmployeesComponent.text_validUntil" | translate : { expirationDate: apiKey.apiKeyExpirationDate | date : "d. MMMM yyyy, H:mm:ss" } }}
                          </span>
                        }
                        @if (apiKey.apiKeyExpirationDate > 9007199254740992) {
                          <span>
                            {{ "Template.EmployeesComponent.text_noExpirationDate" | translate }}
                          </span>
                        }
                      </span>
                    }
                  </div>
                  <div class="col-sm-1 col-md-7">
                    <button type="button" class="btn mx-1 btn-sm btn-outline-danger" placement="top" ngbTooltip="{{ 'Template.EmployeesComponent.tooltip_disableApiKey' | translate }}" (click)="disableApiKey(apiKey)">
                      <fa-icon icon="xmark"></fa-icon>
                    </button>
                  </div>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
}
